import React, { ComponentType } from 'react';
import { Card, Flex } from 'antd';
import { theme } from 'styles/colors';
import { Text } from 'components/mvp-typography';

interface InfoCardProps {
  icon: ComponentType,
  title: string;
  body: string;
  style?: React.CSSProperties; // Add style prop
}

function InfoCard(props: InfoCardProps) {
  return (
    <Card
      style={{
        background: theme.primary,
        ...props.style
      }}
    >
      <Flex gap={16}>
        <div>
          <div style={{ width: 40, height: 40, borderRadius: 6, background: '#ffffff20', color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5 }} >
            <props.icon />
          </div>
        </div>
        <div>
          <Text style={{ color: theme.grey.light, fontWeight: '700' }}>
            {props.title}
          </Text>
          <Text style={{ color: theme.grey.light, fontWeight: 'lighter' }}>
            {props.body}
          </Text>
        </div>
      </Flex>
    </Card>
  );
}

export default InfoCard;
